/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BalanceLedger,
    BalanceLedgerFromJSON,
    BalanceLedgerFromJSONTyped,
    BalanceLedgerToJSON,
    Shelf,
    ShelfFromJSON,
    ShelfFromJSONTyped,
    ShelfToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserBalance
 */
export interface UserBalance {
    /**
     * 
     * @type {Array<Shelf>}
     * @memberof UserBalance
     */
    onLoanItems: Array<Shelf>;
    /**
     * 
     * @type {Array<BalanceLedger>}
     * @memberof UserBalance
     */
    activities: Array<BalanceLedger>;
}

export function UserBalanceFromJSON(json: any): UserBalance {
    return UserBalanceFromJSONTyped(json, false);
}

export function UserBalanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserBalance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onLoanItems': ((json['on_loan_items'] as Array<any>).map(ShelfFromJSON)),
        'activities': ((json['activities'] as Array<any>).map(BalanceLedgerFromJSON)),
    };
}

export function UserBalanceToJSON(value?: UserBalance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'on_loan_items': ((value.onLoanItems as Array<any>).map(ShelfToJSON)),
        'activities': ((value.activities as Array<any>).map(BalanceLedgerToJSON)),
    };
}


